__turbopack_context__.v({
  "fullscreen": "ModalSkeleton-module__lLvK5a__fullscreen",
  "large": "ModalSkeleton-module__lLvK5a__large",
  "modal": "ModalSkeleton-module__lLvK5a__modal",
  "modalWrapper": "ModalSkeleton-module__lLvK5a__modalWrapper",
  "overlay": "ModalSkeleton-module__lLvK5a__overlay",
  "small": "ModalSkeleton-module__lLvK5a__small",
});
